import React from 'react'
import styled, { css } from 'styled-components'

import { overlayColors } from '@sketch/utils'

export type NotificationTypeIconSize = 'sm' | 'md'

interface NotificationTypeIconProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  size?: NotificationTypeIconSize
  className?: string
}

const SIZES: Record<
  NotificationTypeIconSize,
  { box: number; svg: number; radius: 'large' | 'xlarge' }
> = {
  sm: { box: 17, svg: 10, radius: 'large' },
  md: { box: 28, svg: 16, radius: 'xlarge' },
}

const Badge = styled.span<{ $size: NotificationTypeIconSize }>(
  ({ theme, $size }) => {
    const { box, svg, radius } = SIZES[$size]
    return css`
      flex-shrink: 0;
      width: ${box}px;
      height: ${box}px;
      border-radius: ${theme.radii[radius]};
      background: ${overlayColors(
        'hsla(0, 0%, 100%, 1)',
        'hsla(0, 0%, 0%, 0.5)'
      )};
      color: ${theme.colors.background.secondary.A};
      display: inline-flex;
      align-items: center;
      justify-content: center;

      > svg {
        width: ${svg}px;
        height: ${svg}px;
      }

      .active & {
        background: ${theme.colors.sketch.A};
      }
    `
  }
)

export const NotificationTypeIcon = ({
  icon: Icon,
  size = 'md',
  className,
}: NotificationTypeIconProps) => (
  <Badge $size={size} aria-hidden className={className}>
    <Icon />
  </Badge>
)
